import styled, { css } from 'styled-components'

import { Colors } from '@fourthwall/components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  gap: var(--space-300);
`
export const PaymentMethodContainer = styled.div<{
  selected: boolean
  invalid: boolean
  selectable: boolean
}>`
  display: flex;
  align-items: center;
  position: relative;
  padding: 12px 16px;
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-brand);

  ${({ selectable }) =>
    selectable &&
    css`
      cursor: pointer;
    `}

  ${({ invalid }) =>
    invalid &&
    css`
      border: 1px solid var(--border-critical);
    `}

  ${({ selected }) =>
    selected &&
    css`
      padding: 11px 15px;
      border: 2px solid var(--border-active);
    `}
`

export const RadioContainer = styled.div`
  margin-right: 14px;
`

export const IconContainer = styled.div`
  margin-right: 16px;
`

export const TitleContainer = styled.div`
  flex: 1;
  position: relative;
  min-height: 24px;
  margin-right: 16px;
`

export const Title = styled.div<{ withEllipsis?: boolean }>`
  font-size: 16px;
  line-height: 150%;

  ${({ withEllipsis }) =>
    withEllipsis &&
    css`
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
`

export const Subtitle = styled.div`
  font-size: 12px;
  line-height: 130%;
  letter-spacing: 0.02em;
  color: ${Colors.GS600};
`

export const TagsContainer = styled.div`
  display: flex;
`

export const TagWrapper = styled.div`
  & + & {
    margin-left: 12px;
  }
`

export const DropdownWrapper = styled.div`
  margin-left: 20px;
`
